import { render } from "./AdditionalComments.vue?vue&type=template&id=24abb7ba&ts=true"
import script from "./AdditionalComments.vue?vue&type=script&lang=ts"
export * from "./AdditionalComments.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__